import React from 'react';
import { withRouter } from 'react-router-dom';
import { get, isEmpty } from 'lodash';
import queryString from 'query-string';

// local dependencies
import { CallWidgetItemDetailService } from 'services/callWidgetItemDetail';
import { callWidgetItemDetail as CallWidgetItemDetailView } from 'ui/views/widgets/callWidgetItemDetail';
import { DASHBOARD } from 'constants/route-paths';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { CallWidgetItemDetail } from 'ui/containers/CallWidgetItemDetail';
 *
 * // render
 * <CallWidgetItemDetail propName='propValue'/>
 */
export class _CallWidgetItemDetail extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );
        
        this.callWidgetItemDetailService = new CallWidgetItemDetailService();
        const queryParams = queryString.parse( this.props.location.search );

        this.handleNavActionClick = this.handleNavActionClick.bind( this );

        this.state = {
            isFetching: true,
            networkStatus: undefined,
            callId: get( queryParams, 'callId' ),
            componentData: undefined,
        };

        // if - `callId` is not present, redirect to the dashboard landing
        // else - make service request for the component data
         if( isEmpty( this.state.callId ) ) {
            this.props.history.replace( DASHBOARD );
        } else{
            this.fetchComponentData(); // start component data fetch
        }
    }

    /**
	 * @desc Fetch component response.
	 */
    async fetchComponentData() {

        log.debug( '_CallWidgetItemDetail.fetchComponentData()' );

        // cancel ongoing request
        this.callWidgetItemDetailService.cancel();

        // get status and service data
        const { status, data } = await this.callWidgetItemDetailService.fetchComponentData( {
            url: this.props.widget.url,
            
            // data: {
            //     data: {},
            //     context: {
            //         callId: this.state.callId,
            //     }
            // }
        } );
        
        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
            } );
        } else {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                componentData: data,
            } );
        }
    }


    handleNavActionClick( { type, value } ) {
        log.debug( '_CallWidgetItemDetail.handleNavActionClick()' );

        if(  'headerAction' === type && 'back' === value.name ) {
            this.props.history.goBack();
        }
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <CallWidgetItemDetailView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                callId={ this.state.callId }
                { ...get( this.state, 'componentData', {} ) }
                requestPayload={ {
                    context: {
                        callId: this.state.callId
                    }
                } }
                onNavActionClick={ this.handleNavActionClick }
            />
        );
    }
}

// set display name
_CallWidgetItemDetail.displayName = '_CallWidgetItemDetail';

// set default props
_CallWidgetItemDetail.defaultProps = {};

// prop types
_CallWidgetItemDetail.propTypes = {};

export const CallWidgetItemDetail = withRouter( _CallWidgetItemDetail );

